<template>
	<div class="troopsInVillages">
		<div class="troopsDetailContainer" ng-repeat="village in troopsInVillage">
			<div class="troopsDetailHeader">
				<span translate=""><span>Всего войск в</span></span> <a ng-class="{disabled: villId <= 2 || nolink}" class="truncated villageLink truncated clickable" clickable="$root.openWindow('mapCellDetails', {'cellId': 536330229}, null, true)" village-link="" villageid="536330229" villagename="Брест">Брест</a>
				<div class="troopsInfo" tooltip="" tooltip-translate="Resource.CropConsumption">
					<span><i class="unit_consumption_small_flat_black"></i> 726 <span translate=""><span>в час</span></span></span>
				</div>
			</div>
			<div troops-details="" ng-repeat="troops in village.troops" troop-data="troops">
				<table class="troopsTable gaul">
					<tbody class="troopsIconRow">
						<tr>
							<td ng-repeat="n in []|range:1:11" class="unit1">
								<i class="unitSmall gaul unitType1" unit-icon="" data="21" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
													clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
								<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
								<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
							</td>
							<td ng-repeat="n in []|range:1:11" class="unit2">
								<i class="unitSmall gaul unitType2" unit-icon="" data="22" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
													clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
								<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
								<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
							</td>
							<td ng-repeat="n in []|range:1:11" class="unit3">
								<i class="unitSmall gaul unitType3" unit-icon="" data="23" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
													clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
								<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
								<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
							</td>
							<td ng-repeat="n in []|range:1:11" class="unit4">
								<i class="unitSmall gaul unitType4" unit-icon="" data="24" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
													clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
								<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
								<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
							</td>
							<td ng-repeat="n in []|range:1:11" class="unit5">
								<i class="unitSmall gaul unitType5" unit-icon="" data="25" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
													clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
								<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
								<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
							</td>
							<td ng-repeat="n in []|range:1:11" class="unit6">
								<i class="unitSmall gaul unitType6 inactive" unit-icon="" data="26" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
													clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
								<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
								<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
							</td>
							<td ng-repeat="n in []|range:1:11" class="unit7">
								<i class="unitSmall gaul unitType7" unit-icon="" data="27" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
													clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
								<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
								<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
							</td>
							<td ng-repeat="n in []|range:1:11" class="unit8">
								<i class="unitSmall gaul unitType8 inactive" unit-icon="" data="28" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
													clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
								<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
								<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
							</td>
							<td ng-repeat="n in []|range:1:11" class="unit9">
								<i class="unitSmall gaul unitType9 inactive" unit-icon="" data="29" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
													clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
								<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
								<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
							</td>
							<td ng-repeat="n in []|range:1:11" class="unit10">
								<i class="unitSmall gaul unitType10 inactive" unit-icon="" data="30" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
													clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
								<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
								<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
							</td>
							<td ng-repeat="n in []|range:1:11" class="hero">
								<i class="unitSmall hero_illu" unit-icon="" data="hero" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
													clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
								<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
								<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
							</td>
						</tr>
					</tbody>
					<tbody ng-if="troopData[troopsType+'Troops']" class="originalTroops" ng-repeat="troopsType in ['original', 'input', 'lost', 'trapped']">
						<!-- ngIf: troopsType == 'trapped' -->
						<tr>
							<td ng-repeat="n in [] | range:1:11" class="unit1">
								<!-- ngIf: troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0) -->
								<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

								<div ng-if="troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1">
									<!-- ngIf: troopsType == 'original' && troopData['inputTroops'] -->
									<span ng-if="(troopsType != 'original' || !troopData['inputTroops']) && !(troopsType == 'lost' && n == Troops.TYPE_HERO && troopData['heroHealthLoss'])">184</span>
									<!-- ngIf: troopsType == 'lost' && n == Troops.TYPE_HERO && troopData['heroHealthLoss'] -->
								</div>
								<!-- ngIf: troopsType == 'input' -->
							</td>
							<td ng-repeat="n in [] | range:1:11" class="unit2">
								<!-- ngIf: troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0) -->
								<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

								<div ng-if="troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1">
									<!-- ngIf: troopsType == 'original' && troopData['inputTroops'] -->
									<span ng-if="(troopsType != 'original' || !troopData['inputTroops']) && !(troopsType == 'lost' && n == Troops.TYPE_HERO && troopData['heroHealthLoss'])">135</span>
									<!-- ngIf: troopsType == 'lost' && n == Troops.TYPE_HERO && troopData['heroHealthLoss'] -->
								</div>
								<!-- ngIf: troopsType == 'input' -->
							</td>
							<td ng-repeat="n in [] | range:1:11" class="unit3">
								<!-- ngIf: troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0) -->
								<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

								<div ng-if="troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1">
									<!-- ngIf: troopsType == 'original' && troopData['inputTroops'] -->
									<span ng-if="(troopsType != 'original' || !troopData['inputTroops']) && !(troopsType == 'lost' && n == Troops.TYPE_HERO && troopData['heroHealthLoss'])">33</span>
									<!-- ngIf: troopsType == 'lost' && n == Troops.TYPE_HERO && troopData['heroHealthLoss'] -->
								</div>
								<!-- ngIf: troopsType == 'input' -->
							</td>
							<td ng-repeat="n in [] | range:1:11" class="unit4">
								<!-- ngIf: troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0) -->
								<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

								<div ng-if="troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1">
									<!-- ngIf: troopsType == 'original' && troopData['inputTroops'] -->
									<span ng-if="(troopsType != 'original' || !troopData['inputTroops']) && !(troopsType == 'lost' && n == Troops.TYPE_HERO && troopData['heroHealthLoss'])">52</span>
									<!-- ngIf: troopsType == 'lost' && n == Troops.TYPE_HERO && troopData['heroHealthLoss'] -->
								</div>
								<!-- ngIf: troopsType == 'input' -->
							</td>
							<td ng-repeat="n in [] | range:1:11" class="unit5">
								<!-- ngIf: troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0) -->
								<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

								<div ng-if="troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1">
									<!-- ngIf: troopsType == 'original' && troopData['inputTroops'] -->
									<span ng-if="(troopsType != 'original' || !troopData['inputTroops']) && !(troopsType == 'lost' && n == Troops.TYPE_HERO && troopData['heroHealthLoss'])">102</span>
									<!-- ngIf: troopsType == 'lost' && n == Troops.TYPE_HERO && troopData['heroHealthLoss'] -->
								</div>
								<!-- ngIf: troopsType == 'input' -->
							</td>
							<td ng-repeat="n in [] | range:1:11" class="unit6">
								<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
								<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

								<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
								<!-- ngIf: troopsType == 'input' -->
							</td>
							<td ng-repeat="n in [] | range:1:11" class="unit7">
								<!-- ngIf: troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0) -->
								<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

								<div ng-if="troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1">
									<!-- ngIf: troopsType == 'original' && troopData['inputTroops'] -->
									<span ng-if="(troopsType != 'original' || !troopData['inputTroops']) && !(troopsType == 'lost' && n == Troops.TYPE_HERO && troopData['heroHealthLoss'])">5</span>
									<!-- ngIf: troopsType == 'lost' && n == Troops.TYPE_HERO && troopData['heroHealthLoss'] -->
								</div>
								<!-- ngIf: troopsType == 'input' -->
							</td>
							<td ng-repeat="n in [] | range:1:11" class="unit8">
								<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
								<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

								<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
								<!-- ngIf: troopsType == 'input' -->
							</td>
							<td ng-repeat="n in [] | range:1:11" class="unit9">
								<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
								<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

								<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
								<!-- ngIf: troopsType == 'input' -->
							</td>
							<td ng-repeat="n in [] | range:1:11" class="unit10">
								<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
								<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

								<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
								<!-- ngIf: troopsType == 'input' -->
							</td>
							<td ng-repeat="n in [] | range:1:11" class="hero">
								<!-- ngIf: troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0) -->
								<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

								<div ng-if="troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1">
									<!-- ngIf: troopsType == 'original' && troopData['inputTroops'] -->
									<span ng-if="(troopsType != 'original' || !troopData['inputTroops']) && !(troopsType == 'lost' && n == Troops.TYPE_HERO && troopData['heroHealthLoss'])">1</span>
									<!-- ngIf: troopsType == 'lost' && n == Troops.TYPE_HERO && troopData['heroHealthLoss'] -->
								</div>
								<!-- ngIf: troopsType == 'input' -->
							</td>
						</tr>
					</tbody>
					<!-- ngIf: troopData.supply -->
					<!-- ngIf: troopData.cagedAnimals -->
				</table>
			</div>
			<div troops-details="" ng-repeat="troops in village.troops" troop-data="troops">
				<table class="troopsTable nature">
					<tbody class="troopsIconRow">
						<tr>
							<td ng-repeat="n in []|range:1:11" class="unit1">
								<i class="unitSmall nature unitType1 inactive" unit-icon="" data="31" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
													clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
								<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
								<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
							</td>
							<td ng-repeat="n in []|range:1:11" class="unit2">
								<i class="unitSmall nature unitType2 inactive" unit-icon="" data="32" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
													clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
								<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
								<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
							</td>
							<td ng-repeat="n in []|range:1:11" class="unit3">
								<i class="unitSmall nature unitType3 inactive" unit-icon="" data="33" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
													clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
								<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
								<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
							</td>
							<td ng-repeat="n in []|range:1:11" class="unit4">
								<i class="unitSmall nature unitType4" unit-icon="" data="34" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
													clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
								<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
								<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
							</td>
							<td ng-repeat="n in []|range:1:11" class="unit5">
								<i class="unitSmall nature unitType5 inactive" unit-icon="" data="35" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
													clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
								<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
								<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
							</td>
							<td ng-repeat="n in []|range:1:11" class="unit6">
								<i class="unitSmall nature unitType6 inactive" unit-icon="" data="36" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
													clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
								<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
								<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
							</td>
							<td ng-repeat="n in []|range:1:11" class="unit7">
								<i class="unitSmall nature unitType7 inactive" unit-icon="" data="37" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
													clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
								<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
								<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
							</td>
							<td ng-repeat="n in []|range:1:11" class="unit8">
								<i class="unitSmall nature unitType8 inactive" unit-icon="" data="38" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
													clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
								<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
								<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
							</td>
							<td ng-repeat="n in []|range:1:11" class="unit9">
								<i class="unitSmall nature unitType9 inactive" unit-icon="" data="39" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
													clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
								<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
								<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
							</td>
							<td ng-repeat="n in []|range:1:11" class="unit10">
								<i class="unitSmall nature unitType10 inactive" unit-icon="" data="40" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
													clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
								<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
								<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
							</td>
							<td ng-repeat="n in []|range:1:11" class="hero">
								<i class="unitSmall hero_illu inactive" unit-icon="" data="hero" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
													clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
								<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
								<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
							</td>
						</tr>
					</tbody>
					<tbody ng-if="troopData[troopsType+'Troops']" class="originalTroops" ng-repeat="troopsType in ['original', 'input', 'lost', 'trapped']">
						<!-- ngIf: troopsType == 'trapped' -->
						<tr>
							<td ng-repeat="n in [] | range:1:11" class="unit1">
								<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
								<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

								<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
								<!-- ngIf: troopsType == 'input' -->
							</td>
							<td ng-repeat="n in [] | range:1:11" class="unit2">
								<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
								<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

								<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
								<!-- ngIf: troopsType == 'input' -->
							</td>
							<td ng-repeat="n in [] | range:1:11" class="unit3">
								<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
								<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

								<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
								<!-- ngIf: troopsType == 'input' -->
							</td>
							<td ng-repeat="n in [] | range:1:11" class="unit4">
								<!-- ngIf: troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0) -->
								<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

								<div ng-if="troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1">
									<!-- ngIf: troopsType == 'original' && troopData['inputTroops'] -->
									<span ng-if="(troopsType != 'original' || !troopData['inputTroops']) && !(troopsType == 'lost' && n == Troops.TYPE_HERO && troopData['heroHealthLoss'])">38</span>
									<!-- ngIf: troopsType == 'lost' && n == Troops.TYPE_HERO && troopData['heroHealthLoss'] -->
								</div>
								<!-- ngIf: troopsType == 'input' -->
							</td>
							<td ng-repeat="n in [] | range:1:11" class="unit5">
								<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
								<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

								<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
								<!-- ngIf: troopsType == 'input' -->
							</td>
							<td ng-repeat="n in [] | range:1:11" class="unit6">
								<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
								<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

								<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
								<!-- ngIf: troopsType == 'input' -->
							</td>
							<td ng-repeat="n in [] | range:1:11" class="unit7">
								<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
								<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

								<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
								<!-- ngIf: troopsType == 'input' -->
							</td>
							<td ng-repeat="n in [] | range:1:11" class="unit8">
								<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
								<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

								<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
								<!-- ngIf: troopsType == 'input' -->
							</td>
							<td ng-repeat="n in [] | range:1:11" class="unit9">
								<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
								<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

								<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
								<!-- ngIf: troopsType == 'input' -->
							</td>
							<td ng-repeat="n in [] | range:1:11" class="unit10">
								<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
								<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

								<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
								<!-- ngIf: troopsType == 'input' -->
							</td>
							<td ng-repeat="n in [] | range:1:11" class="hero">
								<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
								<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

								<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
								<!-- ngIf: troopsType == 'input' -->
							</td>
						</tr>
					</tbody>
					<!-- ngIf: troopData.supply -->
					<!-- ngIf: troopData.cagedAnimals -->
				</table>
			</div>
		</div>
		<div class="troopsDetailContainer" ng-repeat="village in troopsInVillage">
			<div class="troopsDetailHeader">
				<span translate=""><span>Всего войск в</span></span> <a ng-class="{disabled: villId <= 2 || nolink}" class="truncated villageLink truncated clickable" clickable="$root.openWindow('mapCellDetails', {'cellId': 536133632}, null, true)" village-link="" villageid="536133632" villagename="InZectorsk">InZectorsk</a>
				<div class="troopsInfo" content="Потребление" v-tippy="{placement: 'bottom'}">
					<span><i class="unit_consumption_small_flat_black"></i> 9 <span translate=""><span>в час</span></span></span>
				</div>
			</div>
			<div troops-details="" ng-repeat="troops in village.troops" troop-data="troops">
				<table class="troopsTable gaul">
					<tbody class="troopsIconRow">
						<tr>
							<td ng-repeat="n in []|range:1:11" class="unit1">
								<i class="unitSmall gaul unitType1" unit-icon="" data="21" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
													  clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
								<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
								<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
							</td>
							<td ng-repeat="n in []|range:1:11" class="unit2">
								<i class="unitSmall gaul unitType2" unit-icon="" data="22" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
													  clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
								<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
								<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
							</td>
							<td ng-repeat="n in []|range:1:11" class="unit3">
								<i class="unitSmall gaul unitType3 inactive" unit-icon="" data="23" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
													  clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
								<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
								<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
							</td>
							<td ng-repeat="n in []|range:1:11" class="unit4">
								<i class="unitSmall gaul unitType4 inactive" unit-icon="" data="24" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
													  clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
								<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
								<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
							</td>
							<td ng-repeat="n in []|range:1:11" class="unit5">
								<i class="unitSmall gaul unitType5 inactive" unit-icon="" data="25" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
													  clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
								<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
								<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
							</td>
							<td ng-repeat="n in []|range:1:11" class="unit6">
								<i class="unitSmall gaul unitType6 inactive" unit-icon="" data="26" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
													  clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
								<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
								<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
							</td>
							<td ng-repeat="n in []|range:1:11" class="unit7">
								<i class="unitSmall gaul unitType7 inactive" unit-icon="" data="27" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
													  clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
								<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
								<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
							</td>
							<td ng-repeat="n in []|range:1:11" class="unit8">
								<i class="unitSmall gaul unitType8 inactive" unit-icon="" data="28" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
													  clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
								<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
								<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
							</td>
							<td ng-repeat="n in []|range:1:11" class="unit9">
								<i class="unitSmall gaul unitType9 inactive" unit-icon="" data="29" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
													  clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
								<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
								<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
							</td>
							<td ng-repeat="n in []|range:1:11" class="unit10">
								<i class="unitSmall gaul unitType10 inactive" unit-icon="" data="30" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
													  clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
								<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
								<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
							</td>
							<td ng-repeat="n in []|range:1:11" class="hero">
								<i class="unitSmall hero_illu inactive" unit-icon="" data="hero" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
													  clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
								<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
								<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
							</td>
						</tr>
					</tbody>
					<tbody ng-if="troopData[troopsType+'Troops']" class="originalTroops" ng-repeat="troopsType in ['original', 'input', 'lost', 'trapped']">
						<!-- ngIf: troopsType == 'trapped' -->
						<tr>
							<td ng-repeat="n in [] | range:1:11" class="unit1">
								<!-- ngIf: troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0) -->
								<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

								<div ng-if="troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1">
									<!-- ngIf: troopsType == 'original' && troopData['inputTroops'] -->
									<span ng-if="(troopsType != 'original' || !troopData['inputTroops']) && !(troopsType == 'lost' && n == Troops.TYPE_HERO && troopData['heroHealthLoss'])">5</span>
									<!-- ngIf: troopsType == 'lost' && n == Troops.TYPE_HERO && troopData['heroHealthLoss'] -->
								</div>
								<!-- ngIf: troopsType == 'input' -->
							</td>
							<td ng-repeat="n in [] | range:1:11" class="unit2">
								<!-- ngIf: troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0) -->
								<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

								<div ng-if="troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1">
									<!-- ngIf: troopsType == 'original' && troopData['inputTroops'] -->
									<span ng-if="(troopsType != 'original' || !troopData['inputTroops']) && !(troopsType == 'lost' && n == Troops.TYPE_HERO && troopData['heroHealthLoss'])">4</span>
									<!-- ngIf: troopsType == 'lost' && n == Troops.TYPE_HERO && troopData['heroHealthLoss'] -->
								</div>
								<!-- ngIf: troopsType == 'input' -->
							</td>
							<td ng-repeat="n in [] | range:1:11" class="unit3">
								<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
								<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

								<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
								<!-- ngIf: troopsType == 'input' -->
							</td>
							<td ng-repeat="n in [] | range:1:11" class="unit4">
								<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
								<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

								<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
								<!-- ngIf: troopsType == 'input' -->
							</td>
							<td ng-repeat="n in [] | range:1:11" class="unit5">
								<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
								<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

								<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
								<!-- ngIf: troopsType == 'input' -->
							</td>
							<td ng-repeat="n in [] | range:1:11" class="unit6">
								<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
								<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

								<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
								<!-- ngIf: troopsType == 'input' -->
							</td>
							<td ng-repeat="n in [] | range:1:11" class="unit7">
								<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
								<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

								<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
								<!-- ngIf: troopsType == 'input' -->
							</td>
							<td ng-repeat="n in [] | range:1:11" class="unit8">
								<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
								<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

								<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
								<!-- ngIf: troopsType == 'input' -->
							</td>
							<td ng-repeat="n in [] | range:1:11" class="unit9">
								<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
								<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

								<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
								<!-- ngIf: troopsType == 'input' -->
							</td>
							<td ng-repeat="n in [] | range:1:11" class="unit10">
								<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
								<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

								<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
								<!-- ngIf: troopsType == 'input' -->
							</td>
							<td ng-repeat="n in [] | range:1:11" class="hero">
								<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
								<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

								<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
								<!-- ngIf: troopsType == 'input' -->
							</td>
						</tr>
					</tbody>
					<!-- ngIf: troopData.supply -->
					<!-- ngIf: troopData.cagedAnimals -->
				</table>
			</div>
		</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	data: () => ({
		
	}),
	computed: {},
	methods: {},
	components: {},
}
</script>